export const forbiddenExtensions = ['.exe', '.msi', '.bat', '.com', '.dmg', '.deb', '.rpm', '.tar.gz'];
